export default __webpack_public_path__ + "c5016a4af44a22f95873cb8bdc7202ac.svg";